import React from 'react';

const styles = {
  root: {
    color: '#625471',
    margin: 40,
  },
  title: {
    color: '#4A3E56',
    fontSize: 22,
  },
  componentStack: {
    fontSize: 13,
    color: '#7c6a8e',
  },
  errorMessage: {
    background: 'rgb(255, 255, 255) none repeat scroll 0% 0%',
    borderRadius: 4,
    border: '1px solid rgb(209, 202, 216)',
    boxShadow: 'rgba(37, 11, 54, 0.04) 0px 2px 0px',
    marginBottom: 20,
    position: 'relative',
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 12,
    paddingBottom: 6,
  },
};

const FallBackErrorComponent = ({ error, componentStack, resetError }) => {
  return (
    <div style={styles.root}>
      <div style={styles.title}>Une erreur s'est produite</div>
      <div style={styles.errorMessage}>{error.toString()}</div>
      <div style={styles.componentStack}>{componentStack}</div>
      <button
        onClick={() => {
          resetError();
        }}
      >
        Recharger la page
      </button>
    </div>
  );
};

export default FallBackErrorComponent;
